import * as React from 'react';
import { IconProps, IconWrapper } from './IconWrapper';

export const PremiumSpark: React.FC<IconProps> = ({ children, ...props }) => {
  return (
    <IconWrapper {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9994 23C10.8654 23 10.7304 22.973 10.6024 22.917C10.1954 22.74 9.95241 22.316 10.0084 21.876L10.8674 15H3.00041C2.61241 15 2.25941 14.775 2.09441 14.424C1.92941 14.073 1.98341 13.658 2.23241 13.359L12.2324 1.36001C12.5164 1.01801 12.9924 0.907005 13.3984 1.08301C13.8054 1.25901 14.0474 1.68401 13.9924 2.12401L13.1334 9.00001H21.0004C21.3874 9.00001 21.7414 9.22501 21.9054 9.576C22.0704 9.927 22.0164 10.342 21.7684 10.64L11.7684 22.641C11.5734 22.873 11.2904 23 10.9994 23Z"
      />
    </IconWrapper>
  );
};
